/** @format */

import { WarrantiesState, WarrantyCallState } from '@pdp/data-access/interfaces';
import { createReducer, on } from '@ngrx/store';
import {
	autoSelectionIneligibleSkuResolved,
	autoSelectionNoPlanFound,
	autoSelectionPlanFound,
	saveSelectionClicked,
	warrantyCallErrored,
	warrantyCallStarted,
	warrantyCallSuccessful
} from './warranties.actions';
// circular dep workaround
import { warrantyAddtoExistingCartSucceeded } from '../../../../../add-to-cart/data-access/src/lib/+state/add-to-cart.actions';

export const initialWarrantiesState: WarrantiesState = {
	allWarranties: undefined,
	selectedWarranty: undefined,
	warrantyCallState: 'initial'
};

export const warrantiesReducer = createReducer(
	initialWarrantiesState,
	on(warrantyCallStarted, (state) => ({
		...state,
		warrantyCallState: 'loading' as WarrantyCallState
	})),
	on(warrantyCallSuccessful, (state, action) => ({
		...state,
		warrantyCallState: 'success' as WarrantyCallState,
		allWarranties: action.availableWarrantiesResponse?.products
	})),
	on(warrantyCallErrored, (state) => ({
		...state,
		warrantyCallState: 'error' as WarrantyCallState
	})),
	on(
		saveSelectionClicked,
		warrantyAddtoExistingCartSucceeded,
		autoSelectionIneligibleSkuResolved,
		autoSelectionPlanFound,
		autoSelectionNoPlanFound,
		(state, action) => ({
			...state,
			selectedWarranty: action.selectedWarranty
		})
	)
);
